import { render, staticRenderFns } from "./VImportantDateForm.vue?vue&type=template&id=48c59538&"
import script from "./VImportantDateForm.vue?vue&type=script&lang=js&"
export * from "./VImportantDateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports